// src/components/layout/SiteFooter/SiteFooter.tsx
import React from "react";

type SiteFooterProps = {
  currentYear: number;
};

const SiteFooter: React.FC<SiteFooterProps> = ({ currentYear }) => {
  return (
    <footer className="relative z-10 bg-transparent">
      <div aria-hidden="true" className="h-px bg-[#f3dfae]/90" />
      <div className="max-w-7xl mx-auto px-6 py-10 text-white">
        <p className="font-lexend text-[10px] sm:text-[11px] leading-tight text-center">
          <span className="font-bold">© {currentYear} Hysteron Ltd.</span> Admin
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
